import { cn } from '@repo/ui/lib/utils'
import  { ReactNode } from 'react'

interface Props {
  children: ReactNode
  className?: string
}
function SectionChild({ children, className }: Props) {
  return <div className={cn('mx-auto max-w-[1220px] px-4 lg:px-0', className)}>{children}
</div>
}

export default SectionChild
